import { render } from "./CtcWizardSummaryCard.vue?vue&type=template&id=24e1fa82&scoped=true"
import script from "./CtcWizardSummaryCard.vue?vue&type=script&lang=js"
export * from "./CtcWizardSummaryCard.vue?vue&type=script&lang=js"

import "./CtcWizardSummaryCard.vue?vue&type=style&index=0&id=24e1fa82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e1fa82"]])

export default __exports__